import { Link } from "react-router-dom";
import { categories } from "@/mocks/comics";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-300/50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary-500 to-primary-700 text-background-50">
                <i className="ri-fire-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl">炮渣<span className="fire-text">漫画</span>网</span>
            </Link>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              收录无脑爽漫推荐、热血战斗排行、开挂主角漫画与逆袭流合集。龙傲天与打脸爽文漫一网打尽，点开就能按榜单速食开挂剧情，直接开刷。
            </p>
          </div>

          {/* 分类 */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">热门分类</h4>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-3">
              {categories.map((c) => (
                <li key={c.key}>
                  <Link
                    to={`/recommend?cat=${c.name}`}
                    className="text-sm text-foreground-600 hover:text-primary-400 transition-colors"
                  >
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* 快速导航 */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">快捷导航</h4>
            <ul className="space-y-3">
              <li><Link to="/ranking" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">热血战斗排行</Link></li>
              <li><Link to="/recommend" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">无脑爽漫推荐</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">关于我们</Link></li>
              <li><Link to="/faq" className="text-sm text-foreground-600 hover:text-primary-400 transition-colors">常见问题</Link></li>
            </ul>
          </div>

          {/* 联系 */}
          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2"><i className="ri-mail-line text-primary-500"></i>contact@paozhamanhua.com</li>
              <li className="flex items-center gap-2"><i className="ri-wechat-line text-primary-500"></i>官方公众号：炮渣漫画网</li>
              <li className="flex items-center gap-2"><i className="ri-time-line text-primary-500"></i>工作日 9:00 - 21:00</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/50 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-700">
            © {new Date().getFullYear()} 炮渣漫画网 · 无脑爽漫推荐与热血战斗排行门户
          </p>
          <p className="text-xs text-foreground-700">理性追漫，支持正版，随开随刷。</p>
        </div>
      </div>
    </footer>
  );
}